import type { SymbolIndexWorkerOutMessage, SymbolIndexWorkerPort } from './protocol.js';

export function postSafe(port: SymbolIndexWorkerPort, message: SymbolIndexWorkerOutMessage): void {
  try {
    port.postMessage(message);
  } catch {
    /* worker/client may be gone during shutdown */
  }
}
